/* SIZESOFTX
=========================================================================================
* Descripción: Soporte y soluciones - kanban de tickets de tenants con bitácora,
*              respuestas, ligas, adjuntos y arrastre entre estados.
* Revisión 18/09/2026 | José Luis Aragón Cervantes | Tablero y detalle de soporte.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1        | 18/09/2026 | Muse Spark                       | Creación módulo tickets.
* ---------------------------------------------------------------------------------------
*/
import React from 'react';
import TicketBoard from '../components/tickets/TicketBoard';
import { apiTicketsList, apiTicketDetalle, apiTicketResponder, apiTicketAdjuntoDescargar, apiTicketGestion, apiTicketResponsables } from '../settings/supportApi';
const api = {
  list: () => apiTicketsList({}),
  detail: apiTicketDetalle,
  reply: apiTicketResponder,
  download: (_, a) => apiTicketAdjuntoDescargar(a.adjuntoId, a.nombreArchivo),
  manage: apiTicketGestion,
  agents: apiTicketResponsables
};
export default function SoporteTicketsPage() {
  return <TicketBoard api={api} administrative />;
}
